import React, { useMemo } from 'react'
import { Button, Center, Modal, NumberInput, Select, SimpleGrid, Text, TextInput } from '@mantine/core';
import { notifications } from '@mantine/notifications';
import { useDisclosure } from '@mantine/hooks';
import useStepRow from './useStepRow';
import { currencies } from '../currency';

function StepRow({ stepData, index, removeUnusedSteps, globalCurrency }) {
    const {
        step,
        setStep,
        opened,
        open,
        close,
        removeStep,
        saveStep,
        handleCurrencyChange,
        handleInputChange,
        renameStep } = useStepRow(stepData, index, removeUnusedSteps, globalCurrency);
    const currencyOptions = useMemo(() => {
        const target = currencies?.find((item) => item.value === globalCurrency);
        let targetData = [
            {
                label: "Diamonds",
                value: 'diamonds',
            },
        ]
        target && targetData.push(target)
        return targetData
    }, [globalCurrency])
    return (
        <div
            key={step.id}
            style={{ marginBottom: "20px", padding: "10px", border: "1px solid #ddd", borderRadius: "8px" }}
        >
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <h2>{step.name}</h2>
                <Button size="xs" variant="outline" onClick={() => renameStep(step.id)}>
                    Rename
                </Button>
            </div>

            {step?.fields?.map((field, index) => (
                <SimpleGrid
                    cols={{ base: 1, sm: 2, lg: 2 }}
                // breakpoints={[{ maxWidth: 768, cols: 1 }]}
                >
                    <SimpleGrid cols={1}  >
                        <label style={{ flex: 1 }}>{field.label}</label>
                    </SimpleGrid>
                    <SimpleGrid cols={2} style={{ paddingBottom: '10px' }} >
                        <NumberInput
                            placeholder="Enter value"
                            value={field?.value}
                            onChange={(value) => handleInputChange(step?.id, index, value)}
                        //style={{ flex: 1 }}
                        />

                        <Select
                            value={field?.currency}
                            onChange={(newCurrency) => handleCurrencyChange(step.id, index, newCurrency)}
                            data={currencyOptions?.find((item) => item.value !== field?.currency)
                                ? [{
                                    label: field?.currency,
                                    value: field?.currency,
                                }, ...currencyOptions] : currencyOptions}

                            //  disabled={field?.fixed || globalCurrency === "diamonds"} // Prevents changing currency for "Level"
                            style={{ width: "120px" }}
                            searchable

                        />
                    </SimpleGrid>

                </SimpleGrid>

            ))
            }

            <div style={{ display: "flex", justifyContent: "space-between", marginTop: "10px" }}>
                <Button mt="md" variant="default" onClick={open}>
                    Delete
                </Button>
                <Button
                    mt="md"
                    variant="gradient"
                    gradient={{ from: "#44FFFA", to: "#FF4267", deg: 90 }}
                    onClick={() => saveStep(step.id)}
                >
                    Save
                </Button>
                <Modal opened={opened} onClose={close}
                    centered
                    title="Confirm">

                    <Text>Are you sure you want to delete {step?.name} step ?</Text>


                    <Center mt={"md"}>
                        <Button onClick={() => removeStep(step.id)}
                        // loading={isPending}
                        >Confirm</Button>
                    </Center>

                </Modal>
            </div>
        </div >)
}

export default StepRow
